import App from './components/App'
import { RecoilRoot } from 'recoil'
import '@fontsource/dm-sans/400.css'
import '@fontsource/dm-sans/500.css'
import '@fontsource/dm-sans/600.css'
import '@fontsource/dm-sans/700.css'
import '@fontsource/space-grotesk/700.css'
import './assets/styles/index.css'
import ReactDOM from 'react-dom/client'
import React from 'react'
import './translation/i18n'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorScreen } from './screens'
import Modal from 'react-modal'

const rootElement = document.getElementById('root') as HTMLElement
const root = ReactDOM.createRoot(rootElement)
Modal.setAppElement(rootElement)

root.render(
  <RecoilRoot>
    <ErrorBoundary FallbackComponent={ErrorScreen}>
      <App />
    </ErrorBoundary>
  </RecoilRoot>
)
